const wp = '.wikipedia.org/wiki/$1'
const wm = '.wikimedia.org/wiki/$1'
const w = 'www.'

export default {
  acronym: w + 'acronymfinder.com/$1.html',
  advisory: 'advisory' + wm,
  advogato: w + 'advogato.org/$1',
  aew: 'wiki.arabeyes.org/$1',
  appropedia: w + 'appropedia.org/$1',
  aquariumwiki: w + 'theaquariumwiki.com/$1',
  arborwiki: 'localwiki.org/ann-arbor/$1',
  arxiv: 'arxiv.org/abs/$1',
  atmwiki: w + 'otterstedt.de/wiki/index.php/$1',
  baden: w + 'stadtwiki-baden-baden.de/wiki/$1/',
  battlestarwiki: 'en.battlestarwiki.org/wiki/$1',
  bcnbio: 'historiapolitica.bcn.cl/resenas_parlamentarias/wiki/$1',
  beacha: w + 'beachapedia.org/$1',
  betawiki: 'translatewiki.net/wiki/$1',
  bibcode: 'adsabs.harvard.edu/abs/$1',
  bibliowiki: 'wikilivres.org/wiki/$1',
  bluwiki: 'bluwiki.com/go/$1',
  blw: 'britainloves' + wp,
  botwiki: 'botwiki.sno.cc/wiki/$1',
  boxrec: w + 'boxrec.com/media/index.php?$1',
  brickwiki: w + 'brickwiki.info/wiki/$1',
  bugzilla: 'bugzilla.wikimedia.org/show_bug.cgi?id=$1',
  bulba: 'bulbapedia.bulbagarden.net/wiki/$1',
  c: 'commons' + wm,
  c2: 'c2.com/cgi/wiki?$1',
  c2find: 'c2.com/cgi/wiki?FindPage&value=$1',
  cache: w + 'google.com/search?q=cache:$1',
  ĉej: 'esperanto.blahus.cz/cxej/vikio/index.php/$1',
  cellwiki: 'cell.wikia.com/wiki/$1',
  centralwikia: 'community.wikia.com/wiki/$1',
  chej: 'esperanto.blahus.cz/cxej/vikio/index.php/$1',
  choralwiki: w + 'cpdl.org/wiki/index.php/$1',
  citizendium: 'en.citizendium.org/wiki/$1',
  ckwiss: w + 'ck-wissen.de/ckwiki/index.php?title=$1',
  comixpedia: w + 'comixpedia.org/index.php?title=$1',
  commons: 'commons' + wm,
  communityscheme: 'community.schemewiki.org/?c=s&key=$1',
  communitywiki: 'communitywiki.org/$1',
  comune: 'rete.comuni-italiani.it/wiki/$1',
  creativecommons: 'creativecommons.org/licenses/$1',
  creativecommonswiki: 'wiki.creativecommons.org/$1',
  cxej: 'esperanto.blahus.cz/cxej/vikio/index.php/$1',
  dcc: w + 'dccwiki.com/$1',
  dcdatabase: 'dc.wikia.com/$1',
  dcma: 'christian-morgenstern.de/dcma/index.php?title=$1',
  debian: 'wiki.debian.org/$1',
  delicious: w + 'delicious.com/tag/$1',
  devmo: 'developer.mozilla.org/en/docs/$1',
  dictionary: w + 'dict.org/bin/Dict?Database=*&Form=Dict1&Strategy=*&Query=$1',
  dict: w + 'dict.org/bin/Dict?Database=*&Form=Dict1&Strategy=*&Query=$1',
  disinfopedia: 'sourcewatch.org/index.php/$1',
  distributedproofreaders: w + 'pgdp.net/wiki/$1',
  distributedproofreadersca: w + 'pgdpcanada.net/wiki/index.php/$1',
  dmoz: 'curlie.org/$1',
  dmozs: 'curlie.org/search?q=$1',
  doi: 'doi.org/$1',
  donate: 'donate' + wm,
  doom_wiki: 'doom.wikia.com/wiki/$1',
  download: 'releases.wikimedia.org/$1',
  dbdump: 'dumps.wikimedia.org/$1/latest/',
  dpd: 'lema.rae.es/dpd/?key=$1',
  drae: 'dle.rae.es/?w=$1',
  dreamhost: 'wiki.dreamhost.com/index.php/$1',
  drumcorpswiki: w + 'drumcorpswiki.com/index.php/$1',
  dwjwiki: w + 'suberic.net/cgi-bin/dwj/wiki.cgi?$1',
  eĉei: w + 'ikso.net/cgi-bin/wiki.pl?$1',
  ecoreality: w + 'EcoReality.org/wiki/$1',
  ecxei: w + 'ikso.net/cgi-bin/wiki.pl?$1',
  elibre: 'enciclopedia.us.es/index.php/$1',
  emacswiki: w + 'emacswiki.org/emacs?$1',
  encyc: 'encyc.org/wiki/$1',
  energiewiki: w + 'netzwerk-energieberater.de/wiki/index.php/$1',
  englyphwiki: 'en.glyphwiki.org/wiki/$1',
  enkol: 'enkol.pl/$1',
  eokulturcentro: 'esperanto.toulouse.free.fr/nova/wikini/wakka.php?wiki=$1',
  esolang: 'esolangs.org/wiki/$1',
  etherpad: 'etherpad.wikimedia.org/$1',
  ethnologue: w + 'ethnologue.com/language/$1',
  ethnologuefamily: w + 'ethnologue.com/show_family.asp?subid=$1',
  evowiki: 'wiki.cotch.net/index.php/$1',
  exotica: w + 'exotica.org.uk/wiki/$1',
  fanimutationwiki: 'wiki.animutationportal.com/index.php/$1',
  fedora: 'fedoraproject.org/wiki/$1',
  finalfantasy: 'finalfantasy.wikia.com/wiki/$1',
  finnix: w + 'finnix.org/$1',
  flickruser: w + 'flickr.com/people/$1',
  flickrphoto: w + 'flickr.com/photo.gne?id=$1',
  floralwiki: w + 'floralwiki.co.uk/wiki/$1',
  foldoc: 'foldoc.org/$1',
  foundation: 'foundation' + wm,
  foundationsite: 'wikimediafoundation.org/$1',
  foxwiki: 'fox.wikis.com/wc.dll?Wiki~$1',
  freebio: 'freebiology.org/wiki/$1',
  freebsdman: w + 'FreeBSD.org/cgi/man.cgi?apropos=1&query=$1',
  freeculturewiki: 'wiki.freeculture.org/index.php/$1',
  freedomdefined: 'freedomdefined.org/$1',
  freefeel: 'freefeel.org/wiki/$1',
  freekiwiki: 'wiki.freegeek.org/index.php/$1',
  // freenode: 'irc://irc.freenode.net/$1',
  freesoft: 'directory.fsf.org/wiki/$1',
  ganfyd: 'ganfyd.org/index.php?title=$1',
  gardenology: w + 'gardenology.org/wiki/$1',
  gausswiki: 'gauss.ffii.org/$1',
  gentoo: 'wiki.gentoo.org/wiki/$1',
  genwiki: 'wiki.genealogy.net/index.php/$1',
  gerrit: 'gerrit.wikimedia.org/r/$1',
  git: 'gerrit.wikimedia.org/g/$1',
  google: w + 'google.com/search?q=$1',
  googledefine: w + 'google.com/search?q=define:$1',
  googlegroups: 'groups.google.com/groups?q=$1',
  guildwarswiki: 'wiki.guildwars.com/wiki/$1',
  guildwiki: 'guildwars.wikia.com/wiki/$1',
  guc: 'tools.wmflabs.org/guc/?user=$1',
  gucprefix: 'tools.wmflabs.org/guc/?isPrefixPattern=1&src=rc&user=$1',
  gutenberg: w + 'gutenberg.org/etext/$1',
  gutenbergwiki: w + 'gutenberg.org/wiki/$1',
  hackerspaces: 'hackerspaces.org/wiki/$1',
  h2wiki: 'halowiki.net/p/$1',
  hammondwiki: w + 'dairiki.org/HammondWiki/index.php3?$1',
  hdl: 'hdl.handle.net/$1',
  heraldik: 'heraldik-wiki.de/wiki/$1',
  heroeswiki: 'heroeswiki.com/$1',
  horizonlabs: 'horizon.wikimedia.org/$1',
  hrwiki: w + 'hrwiki.org/index.php/$1',
  hrfwiki: 'fanstuff.hrwiki.org/index.php/$1',
  hupwiki: 'wiki.hup.hu/index.php/$1',
  iarchive: 'archive.org/details/$1',
  imdbname: w + 'imdb.com/name/nm$1/',
  imdbtitle: w + 'imdb.com/title/tt$1/',
  imdbcompany: w + 'imdb.com/company/co$1/',
  imdbcharacter: w + 'imdb.com/character/ch$1/',
  incubator: 'incubator' + wm,
  infosecpedia: 'infosecpedia.org/wiki/$1',
  infosphere: 'theinfosphere.org/$1',
  // irc: 'irc://irc.freenode.net/$1',
  // ircs: 'ircs://irc.freenode.net/$1',
  // ircrc: 'irc://irc.wikimedia.org/$1',
  // rcirc: 'irc://irc.wikimedia.org/$1',
  'iso639-3': 'iso639-3.sil.org/code/$1',
  issn: w + 'worldcat.org/issn/$1',
  iuridictum: 'iuridictum.pecina.cz/w/$1',
  jaglyphwiki: 'glyphwiki.org/wiki/$1',
  jefo: 'esperanto-jeunes.org/wiki/$1',
  jerseydatabase: 'jerseydatabase.com/wiki.php?id=$1',
  jira: 'jira.toolserver.org/browse/$1',
  jspwiki: w + 'ecyrd.com/JSPWiki/Wiki.jsp?page=$1',
  jstor: w + 'jstor.org/journals/$1',
  kamelo: 'kamelopedia.mormo.org/index.php/$1',
  karlsruhe: 'ka.stadtwiki.net/$1',
  kinowiki: 'kino.skripov.com/index.php/$1',
  komicawiki: 'wiki.komica.org/?$1',
  kontuwiki: 'kontu.wiki/$1',
  wikitech: 'wikitech' + wm,
  libreplanet: 'libreplanet.org/wiki/$1',
  linguistlist: 'linguistlist.org/forms/langs/LLDescription.cfm?code=$1',
  linuxwiki: w + 'linuxwiki.de/$1',
  linuxwikide: w + 'linuxwiki.de/$1',
  liswiki: 'liswiki.org/wiki/$1',
  literateprograms: 'en.literateprograms.org/$1',
  livepedia: w + 'livepedia.gr/index.php?title=$1',
  localwiki: 'localwiki.org/$1',
  lojban: 'mw.lojban.org/papri/$1',
  lostpedia: 'lostpedia.wikia.com/wiki/$1',
  lqwiki: 'wiki.linuxquestions.org/wiki/$1',
  luxo: 'tools.wmflabs.org/guc/?user=$1',
  mail: 'lists.wikimedia.org/mailman/listinfo/$1',
  mailarchive: 'lists.wikimedia.org/pipermail/$1',
  mariowiki: w + 'mariowiki.com/$1',
  marveldatabase: w + 'marveldatabase.com/wiki/index.php/$1',
  meatball: 'meatballwiki.org/wiki/$1',
  mw: w + 'mediawiki.org/wiki/$1',
  mediazilla: 'bugzilla.wikimedia.org/$1',
  memoryalpha: 'memory-alpha.fandom.com/wiki/$1',
  metawiki: 'meta' + wm,
  metawikimedia: 'meta' + wm,
  metawikipedia: 'meta' + wm,
  mineralienatlas: w + 'mineralienatlas.de/lexikon/index.php/$1',
  moinmoin: 'moinmo.in/$1',
  monstropedia: w + 'monstropedia.org/?title=$1',
  mosapedia: 'mosapedia.de/wiki/index.php/$1',
  mozcom: 'mozilla.wikia.com/wiki/$1',
  mozillawiki: 'wiki.mozilla.org/$1',
  mozillazinekb: 'kb.mozillazine.org/$1',
  musicbrainz: 'musicbrainz.org/doc/$1',
  mediawikiwiki: w + 'mediawiki.org/wiki/$1',
  mwod: w + 'merriam-webster.com/dictionary/$1',
  mwot: w + 'merriam-webster.com/thesaurus/$1',
  nkcells: w + 'nkcells.info/index.php?title=$1',
  nara: 'catalog.archives.gov/id/$1',
  nosmoke: 'no-smok.net/nsmk/$1',
  nost: 'nostalgia' + wp,
  nostalgia: 'nostalgia' + wp,
  oeis: 'oeis.org/$1',
  oldwikisource: 'wikisource.org/wiki/$1',
  olpc: 'wiki.laptop.org/go/$1',
  omegawiki: w + 'omegawiki.org/Expression:$1',
  onelook: w + 'onelook.com/?ls=b&w=$1',
  openlibrary: 'openlibrary.org/$1',
  openstreetmap: 'wiki.openstreetmap.org/wiki/$1',
  openwetware: 'openwetware.org/wiki/$1',
  opera7wiki: 'operawiki.info/$1',
  organicdesign: w + 'organicdesign.co.nz/$1',
  orthodoxwiki: 'orthodoxwiki.org/$1',
  osmwiki: 'wiki.openstreetmap.org/wiki/$1',
  otrs: 'ticket.wikimedia.org/otrs/index.pl?Action=AgentTicketZoom&TicketID=$1',
  otrswiki: 'otrs-wiki' + wm,
  ourmedia: w + 'socialtext.net/ourmedia/index.cgi?$1',
  outreach: 'outreach' + wm,
  outreachwiki: 'outreach' + wm,
  owasp: w + 'owasp.org/index.php/$1',
  panawiki: 'wiki.alairelibre.net/index.php?title=$1',
  patwiki: 'gauss.ffii.org/$1',
  personaltelco: 'personaltelco.net/wiki/$1',
  petscan: 'petscan.wmflabs.org/?psid=$1',
  phab: 'phabricator.wikimedia.org/$1',
  phabricator: 'phabricator.wikimedia.org/$1',
  phwiki: w + 'pocketheaven.com/ph/wiki/index.php?title=$1',
  phpwiki: 'phpwiki.sourceforge.net/phpwiki/index.php?$1',
  planetmath: 'planetmath.org/node/$1',
  pmeg: w + 'bertilow.com/pmeg/$1',
  pmid: w + 'ncbi.nlm.nih.gov/pubmed/$1?dopt=Abstract',
  pokewiki: 'pokewiki.de/$1',
  pokéwiki: 'pokewiki.de/$1',
  policy: 'policy.wikimedia.org/$1',
  proofwiki: w + 'proofwiki.org/wiki/$1',
  pyrev: w + 'mediawiki.org/wiki/Special:Code/pywikipedia/$1',
  pythoninfo: 'wiki.python.org/moin/$1',
  pythonwiki: w + 'pythonwiki.de/$1',
  pywiki: 'c2.com/cgi/wiki?$1',
  psycle: 'psycle.sourceforge.net/wiki/$1',
  quality: 'quality' + wm,
  quarry: 'quarry.wmflabs.org/$1',
  regiowiki: 'regiowiki.at/wiki/$1',
  rev: w + 'mediawiki.org/wiki/Special:Code/MediaWiki/$1',
  revo: 'purl.org/NET/voko/revo/art/$1.html',
  rfc: 'tools.ietf.org/html/rfc$1',
  rheinneckar: 'rhein-neckar-wiki.de/$1',
  robowiki: 'robowiki.net/?$1',
  rodovid: 'en.rodovid.org/wk/$1',
  reuterswiki: 'glossary.reuters.com/index.php/$1',
  rowiki: 'wiki.rennkuckuck.de/index.php/$1',
  rt: 'rt.wikimedia.org/Ticket/Display.html?id=$1',
  // rtfm: 'ftp://rtfm.mit.edu/pub/faqs/$1',
  s23wiki: 's23.org/wiki/$1',
  scholar: 'scholar.google.com/scholar?q=$1',
  schoolswp: 'schools-' + wp,
  scores: 'imslp.org/wiki/$1',
  scoutwiki: 'en.scoutwiki.org/$1',
  scramble: w + 'scramble.nl/wiki/index.php?title=$1',
  seapig: w + 'seapig.org/$1',
  seattlewiki: 'seattle.wikia.com/wiki/$1',
  slwiki: 'wiki.secondlife.com/wiki/$1',
  'semantic-mw': w + 'semantic-mediawiki.org/wiki/$1',
  senseislibrary: 'senseis.xmp.net/?$1',
  sharemap: 'sharemap.org/$1',
  silcode: w + 'sil.org/iso639-3/documentation.asp?id=$1',
  slashdot: 'slashdot.org/article.pl?sid=$1',
  sourceforge: 'sourceforge.net/$1',
  spcom: 'spcom' + wm,
  species: 'species' + wm,
  squeak: 'wiki.squeak.org/squeak/$1',
  stats: 'stats.wikimedia.org/$1',
  stewardry: 'tools.wmflabs.org/meta/stewardry/?wiki=$1',
  strategy: 'strategy' + wm,
  strategywiki: 'strategywiki.org/wiki/$1',
  sulutil: 'meta.wikimedia.org/wiki/Special:CentralAuth/$1',
  swtrain: 'train.spottingworld.com/$1',
  svn: 'svn.wikimedia.org/viewvc/mediawiki/$1?view=log',
  swinbrain: 'swinbrain.ict.swin.edu.au/wiki/$1',
  tabwiki: w + 'tabwiki.com/index.php/$1',
  tclerswiki: 'wiki.tcl.tk/$1',
  technorati: w + 'technorati.com/search/$1',
  tenwiki: 'ten' + wp,
  testwiki: 'test' + wp,
  testwikidata: 'test.wikidata.org/wiki/$1',
  test2wiki: 'test2' + wp,
  tfwiki: 'tfwiki.net/wiki/$1',
  thelemapedia: w + 'thelemapedia.org/index.php/$1',
  theopedia: w + 'theopedia.com/$1',
  thinkwiki: w + 'thinkwiki.org/wiki/$1',
  ticket: 'ticket.wikimedia.org/otrs/index.pl?Action=AgentTicketZoom&TicketNumber=$1',
  tmbw: 'tmbw.net/wiki/$1',
  tmnet: w + 'technomanifestos.net/?$1',
  tmwiki: w + 'EasyTopicMaps.com/?page=$1',
  toolforge: 'tools.wmflabs.org/$1',
  toollabs: 'tools.wmflabs.org/$1',
  tools: 'toolserver.org/$1',
  tswiki: w + 'mediawiki.org/wiki/Toolserver:$1',
  translatewiki: 'translatewiki.net/wiki/$1',
  tviv: 'tviv.org/wiki/$1',
  tvtropes: w + 'tvtropes.org/pmwiki/pmwiki.php/Main/$1',
  twiki: 'twiki.org/cgi-bin/view/$1',
  tyvawiki: w + 'tyvawiki.org/wiki/$1',
  umap: 'umap.openstreetmap.fr/$1',
  uncyclopedia: 'en.uncyclopedia.co/wiki/$1',
  unihan: w + 'unicode.org/cgi-bin/GetUnihanData.pl?codepoint=$1',
  unreal: 'wiki.beyondunreal.com/wiki/$1',
  urbandict: w + 'urbandictionary.com/define.php?term=$1',
  usej: w + 'tejo.org/usej/$1',
  usemod: w + 'usemod.com/cgi-bin/wiki.pl?$1',
  usability: 'usability' + wm,
  utrs: 'utrs.wmflabs.org/appeal.php?id=$1',
  vikidia: 'fr.vikidia.org/wiki/$1',
  vlos: 'tusach.thuvienkhoahoc.com/wiki/$1',
  vkol: 'kol.coldfront.net/thekolwiki/index.php/$1',
  voipinfo: w + 'voip-info.org/wiki/view/$1',
  votewiki: 'vote' + wm,
  werelate: w + 'werelate.org/wiki/$1',
  wg: 'wg-en' + wp,
  wikia: w + 'wikia.com/wiki/w:c:$1',
  wikiasite: w + 'wikia.com/wiki/w:c:$1',
  wikiapiary: 'wikiapiary.com/wiki/$1',
  wikibooks: 'en.wikibooks.org/wiki/$1',
  wikichristian: w + 'wikichristian.org/index.php?title=$1',
  wikicities: w + 'wikia.com/wiki/w:$1',
  wikicity: w + 'wikia.com/wiki/w:c:$1',
  wikiconference: 'wikiconference.org/wiki/$1',
  wikidata: w + 'wikidata.org/wiki/$1',
  wikif1: w + 'wikif1.org/$1',
  wikifur: 'en.wikifur.com/wiki/$1',
  wikihow: w + 'wikihow.com/$1',
  wikiindex: 'wikiindex.org/$1',
  wikilemon: 'wiki.illemonati.com/$1',
  wikilivres: 'wikilivres.org/wiki/$1',
  wikilivresru: 'wikilivres.ru/$1',
  'wikimac-de': 'apfelwiki.de/wiki/Main/$1',
  wikimedia: 'foundation' + wm,
  wikinews: 'en.wikinews.org/wiki/$1',
  wikinfo: 'wikinfo.org/w/index.php/$1',
  wikinvest: 'meta.wikimedia.org/wiki/Interwiki_map/discontinued#Wikinvest',
  wikiotics: 'wikiotics.org/$1',
  wikipapers: 'wikipapers.referata.com/wiki/$1',
  wikipedia: 'en' + wp,
  wikipediawikipedia: 'en.wikipedia.org/wiki/Wikipedia:$1',
  wikiquote: 'en.wikiquote.org/wiki/$1',
  wikisophia: 'wikisophia.org/index.php?title=$1',
  wikisource: 'en.wikisource.org/wiki/$1',
  wikispecies: 'species' + wm,
  wikispot: 'wikispot.org/?action=gotowikipage&v=$1',
  wikiskripta: w + 'wikiskripta.eu/index.php/$1',
  labsconsole: 'wikitech' + wm,
  wikiti: 'wikiti.denglend.net/index.php?title=$1',
  wikiversity: 'en.wikiversity.org/wiki/$1',
  wikivoyage: 'en.wikivoyage.org/wiki/$1',
  betawikiversity: 'beta.wikiversity.org/wiki/$1',
  wikiwikiweb: 'c2.com/cgi/wiki?$1',
  wiktionary: 'en.wiktionary.org/wiki/$1',
  wipipedia: 'wipipedia.org/index.php/$1',
  wlug: w + 'wlug.org.nz/$1',
  wmam: 'am' + wm,
  wmar: w + 'wikimedia.org.ar/wiki/$1',
  wmat: 'mitglieder.wikimedia.at/$1',
  wmau: 'wikimedia.org.au/wiki/$1',
  wmbd: 'bd' + wm,
  wmbe: 'be' + wm,
  wmbr: 'br' + wm,
  wmca: 'ca' + wm,
  wmch: w + 'wikimedia.ch/$1',
  wmcl: w + 'wikimediachile.cl/index.php?title=$1',
  wmcn: 'cn' + wm,
  wmco: 'co' + wm,
  wmcz: w + 'wikimedia.cz/web/$1',
  wmdc: 'wikimediadc.org/wiki/$1',
  securewikidc: 'secure.wikidc.org/$1',
  wmde: 'wikimedia.de/wiki/$1',
  wmdk: 'dk' + wm,
  wmee: 'ee' + wm,
  wmec: 'ec' + wm,
  wmes: w + 'wikimedia.es/wiki/$1',
  wmet: 'ee' + wm,
  wmfdashboard: 'outreachdashboard.wmflabs.org/$1',
  wmfi: 'fi' + wm,
  wmfr: 'wikimedia.fr/$1',
  wmge: 'ge' + wm,
  wmhi: 'hi' + wm,
  wmhk: 'meta.wikimedia.org/wiki/Wikimedia_Hong_Kong',
  wmhu: 'wikimedia.hu/wiki/$1',
  wmid: 'id' + wm,
  wmil: w + 'wikimedia.org.il/$1',
  wmin: 'wiki.wikimedia.in/$1',
  wmit: 'wiki.wikimedia.it/wiki/$1',
  wmke: 'meta.wikimedia.org/wiki/Wikimedia_Kenya',
  wmmk: 'mk' + wm,
  wmmx: 'mx' + wm,
  wmnl: 'nl' + wm,
  wmnyc: 'nyc' + wm,
  wmno: 'no' + wm,
  'wmpa-us': 'pa-us' + wm,
  wmph: 'meta.wikimedia.org/wiki/Wikimedia_Philippines',
  wmpl: 'pl' + wm,
  wmpt: 'pt' + wm,
  wmpunjabi: 'punjabi' + wm,
  wmromd: 'romd' + wm,
  wmrs: 'rs' + wm,
  wmru: 'ru' + wm,
  wmse: 'se' + wm,
  wmsk: 'wikimedia.sk/$1',
  wmtr: 'tr' + wm,
  wmtw: 'wikimedia.tw/wiki/index.php5/$1',
  wmua: 'ua' + wm,
  wmuk: 'wikimedia.org.uk/wiki/$1',
  wmve: 'wikimedia.org.ve/wiki/$1',
  wmza: 'wikimedia.org.za/wiki/$1',
  wm2005: 'wikimania2005' + wm,
  wm2006: 'wikimania2006' + wm,
  wm2007: 'wikimania2007' + wm,
  wm2008: 'wikimania2008' + wm,
  wm2009: 'wikimania2009' + wm,
  wm2010: 'wikimania2010' + wm,
  wm2011: 'wikimania2011' + wm,
  wm2012: 'wikimania2012' + wm,
  wm2013: 'wikimania2013' + wm,
  wm2014: 'wikimania2014' + wm,
  wm2015: 'wikimania2015' + wm,
  wm2016: 'wikimania2016' + wm,
  wm2017: 'wikimania2017' + wm,
  wm2018: 'wikimania2018' + wm,
  wmania: 'wikimania' + wm,
  wikimania: 'wikimania' + wm,
  wmteam: 'wikimaniateam' + wm,
  wmf: 'foundation' + wm,
  wmfblog: 'blog.wikimedia.org/$1',
  wmdeblog: 'blog.wikimedia.de/$1',
  wookieepedia: 'starwars.wikia.com/wiki/$1',
  wowwiki: w + 'wowwiki.com/$1',
  wqy: 'wqy.sourceforge.net/cgi-bin/index.cgi?$1',
  wurmpedia: 'wurmpedia.com/index.php/$1',
  viaf: 'viaf.org/viaf/$1',
  zrhwiki: w + 'zrhwiki.ch/wiki/$1',
  zum: 'wiki.zum.de/$1',
  zwiki: w + 'zwiki.org/$1',
  m: 'meta' + wm,
  meta: 'meta' + wm,
  sep11: 'sep11' + wp,
  d: w + 'wikidata.org/wiki/$1',
  minnan: 'zh-min-nan' + wp,
  nb: 'no' + wp,
  'zh-cfr': 'zh-min-nan' + wp,
  'zh-cn': 'zh' + wp,
  'zh-tw': 'zh' + wp,
  nan: 'zh-min-nan' + wp,
  vro: 'fiu-vro' + wp,
  cmn: 'zh' + wp,
  lzh: 'zh-classical' + wp,
  rup: 'roa-rup' + wp,
  gsw: 'als' + wp,
  'be-tarask': 'be-x-old' + wp,
  sgs: 'bat-smg' + wp,
  egl: 'eml' + wp,
  w: 'en' + wp,
  wikt: 'en.wiktionary.org/wiki/$1',
  q: 'en.wikiquote.org/wiki/$1',
  b: 'en.wikibooks.org/wiki/$1',
  n: 'en.wikinews.org/wiki/$1',
  s: 'en.wikisource.org/wiki/$1',
  chapter: 'en' + wm,
  v: 'en.wikiversity.org/wiki/$1',
  voy: 'en.wikivoyage.org/wiki/$1',
}
